import { ref } from 'vue';

export function useLocalStorage(key: string, defaultValue?: string | boolean) {
  const localStorageValue = window.localStorage.getItem(key);

  const value = ref(localStorageValue ?? defaultValue);

  const set = (payload: string) => {
    value.value = payload;
    window.localStorage.setItem(key, payload);
  };

  return {
    set,
    value,
  };
}

export function useBooleanLocalStorage(key: string, defaultValue = false) {
  const { set: setOriginal, value: valueOriginal } = useLocalStorage(key, JSON.stringify(defaultValue));

  const value = ref<boolean>(valueOriginal.value === 'true');

  const set = (payload: boolean) => {
    value.value = payload;
    setOriginal(JSON.stringify(payload));
  };

  return { set, value };
}
